var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.appShow)?_c('router-view'):_vm._e(),_c('JGPlatForm',{ref:"jgPlatForm",attrs:{"jgPlatClass":_vm.jgPlatClass,"jgPlatOption":_vm.jgPlatOption}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }